<section id="clinic" class="py-5 bg-white" appScrollReveal>
  <div class="container">
    <h2 class="section-title">Clinic Details</h2>
    <div class="row g-4">
      <div class="col-md-6">
        <h5 class="fw-semibold">Shree Radha Clinic</h5>
        <p class="small mb-2"><strong>Address:</strong> 181, 1st Floor, Kananshree Villa, Patia, Bhubaneswar<br><span class="text-muted">(Landmark: Near Punjab national Bank)</span></p>
        <div class="mt-2">
          <a class="btn btn-outline-primary btn-sm" target="_blank" rel="noopener" [href]="directionsUrl">Directions</a>
        </div>
        <p class="small mb-2"><strong>Timings:</strong><br>Monday – Saturday: 6:30 PM – 8:30 PM<br>Sunday: Closed</p>
      </div>
      <div class="col-md-6">
        <div class="ratio ratio-4x3 bg-light border rounded overflow-hidden">
          <iframe title="Clinic Location" width="100%" height="100%" style="border:0" loading="lazy" allowfullscreen
            referrerpolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1870.5207982784966!2d85.82132357100281!3d20.339900198333236!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a1909bc0a0a77cd%3A0x7e490dab30b8a48b!2sDr.%20Pragyan%20Routray%20%7C%20Medicine%20Specialist%20Bhubaneswar!5e0!3m2!1sen!2sin!4v1764143354642!5m2!1sen!2sin">
          </iframe>
        </div>
        <div class="mt-2 d-flex justify-content-end">
          <a class="btn btn-outline-primary btn-sm" target="_blank" rel="noopener" [href]="directionsUrl">Directions</a>
        </div>
      </div>
    </div>
  </div>
</section>
